import * as React from 'react';
import { Form } from 'react-bootstrap';
import { getLocalization } from 'global/global';
import { ModalComponentNames, ModalInterface } from 'Interfaces/ModalInterface';
import { sendEmail } from 'api/adminApi';
import { pendingToast } from 'actions/adminToast';
import GenericModal from 'views/Modals/GenericModal';

interface Props {
  /** Semicolon separated recipients, taken from the selected grid rows. */
  to: string;
  onClose: () => void;
}

/** Replaces SendEmailView.js. */
export default function SendEmailModal(props: Props) {
  const [subject, setSubject] = React.useState('');
  const [message, setMessage] = React.useState('');

  const send = async () => {
    const notify = pendingToast(getLocalization('sendingEmails'));
    props.onClose();
    try {
      const response = await sendEmail(props.to, subject, message);
      if (response.status === 'OK') {
        notify.succeed(getLocalization('emailsSent'));
      } else {
        notify.fail(getLocalization('errorSendingEmails'));
      }
    } catch (e) {
      console.log(e);
      notify.fail(getLocalization('errorSendingEmails'));
    }
  };

  return (
    <GenericModal
      visible
      title={getLocalization('sendEmail')}
      cancel={props.onClose}
      cancelText={getLocalization('cancel')}
      confirmText={getLocalization('sendEmail')}
      onConfirm={() => void send()}
      body={(
        <>
          <Form.Group>
            <Form.Label>{getLocalization('to')}</Form.Label>
            <Form.Control as="textarea" readOnly value={props.to} />
          </Form.Group>
          <Form.Group>
            <Form.Label>{getLocalization('subject')}</Form.Label>
            <Form.Control value={subject} onChange={(e) => setSubject(e.target.value)} />
          </Form.Group>
          <Form.Group>
            <Form.Label>{getLocalization('message')}</Form.Label>
            {/*
              The legacy dialog used a wysihtml5 editor. Plain text until the app
              gains a rich text component; see the migration notes.
            */}
            <Form.Control
              as="textarea"
              rows={6}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </Form.Group>
        </>
      )}
    />
  );
}

export const showSendEmail = (to: string) => {
  const modalProps: ModalInterface<Props> = {
    component: ModalComponentNames.SendEmailModal,
    props: {
      to,
      onClose: () => {
        (window as any).ReactAppBridge.ReduxActions
          .navigateRemoveModal(ModalComponentNames.SendEmailModal);
      },
    },
  };
  (window as any).ReactAppBridge.ReduxActions.navigateAddModal(modalProps);
};
